import React, { FC } from 'react';
import styled from 'styled-components';

// Cream alert palette, matching the shoot banner / HiddenChildrenNotice
// warning family.
const Wrapper = styled.div`
  background: #fcf8e3;
  border: 1px solid #faf2cc;
  color: #8a6d3b;
  border-radius: 4px;
  padding: 12px 16px;
  margin: 12px 0;
  font-size: 14px;
  line-height: 1.5;
`;

// Dead-end guard for product shapes a config flow cannot handle yet (e.g. a
// bundle child needing more poses/backgrounds than the flow can collect, or a
// group-photo child in a flow with no group gallery support). Rendering this
// instead of a broken or uncompletable configurator tells the customer why
// they cannot proceed.
interface UnsupportedProductConfigProps {
  productName?: string | null;
}

const UnsupportedProductConfig: FC<UnsupportedProductConfigProps> = ({
  productName = null,
}) => (
  <Wrapper role="status" data-testid="unsupported-product-config">
    Product configuration is unsupported
    {productName ? ` for “${productName}”` : ''}. Please contact your studio to
    order this product.
  </Wrapper>
);

export default UnsupportedProductConfig;
